export default __webpack_public_path__ + "static/media/yliopisto1.d4023a14.png";